import React from 'react'
import { Helmet } from 'react-helmet';
import utils from '../../utils';
import RegisterForm from '../../components/auth/RegisterForm';

function RegisterPage() {
    const url = typeof window !== 'undefined' ? window.location.href : '';

    return (
        <div>
            <Helmet>
                <title>Register - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta name="description" content="Join our community and start shopping for the best products today. It's fast and easy." />
            </Helmet>
            <main>
                <div className="flex flex-col md:flex-row min-h-[calc(100vh-60px)]">
                    <div className="relative w-full md:w-1/2 split-bg min-h-[300px] md:min-h-0 flex flex-col justify-center items-center p-8 md:p-12 lg:p-16">
                        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                        <div className="relative z-1 text-center text-white">
                            <h2 className="text-4xl md:text-5xl font-black text-white">Create Your Account</h2>
                            <p className="mt-4 text-lg text-gray-200 max-w-md">{"Join our community and start shopping for the best products today. It's fast and easy."}</p>
                            <div className="mt-6 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 flex items-center justify-center bg-white dark:bg-slate-900 p-3 md:p-5 lg:p-7">
                        <RegisterForm />
                    </div>
                </div>
            </main>
        </div>
    )
}

export default RegisterPage